<h2 mat-dialog-title>{{ reg_id ? 'Update Registration Details' : 'Add Registration Details' }}</h2>

<form [formGroup]="UserForm" (ngSubmit)="onSubmit()">
    <div mat-dialog-content style="padding: 20px 24px;">
        <div class="row" *ngFor="let element of Element_Data">

            <!-- Ticket Category -->
            <div *ngIf="element.fields === 'tic_category' && element.hide_show">
                <mat-label>{{ element.label }}<span *ngIf="element.require">*</span> :</mat-label>
                <mat-radio-group [formControlName]="element.fields">
                    <mat-radio-button *ngFor="let item of event_tic_category" [value]="item.category_id"
                        [disabled]="item.disable_category">
                        {{ item.category }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Payment Screenshot -->
            <div *ngIf="element.fields == 'payment_ss' && element.hide_show">
                <mat-label>{{ element.label }}<span *ngIf="element.require">*</span> :</mat-label>
                <div class="adsimage mt-2" *ngIf="paymentPath">
                    <img [src]="'https://aieventzo.com/upload/' + event_id + '/payment_ss/' + paymentPath"
                        style="width: 100px; height: 100px; object-fit: contain;">
                </div>
                <div class="input-group mb-3">
                    <input type="file" class="form-control" id="paymentFile" accept="image/*"
                        (change)="preview_payment_image($event)">
                </div>
            </div>

            <!-- Profile Image -->
            <div *ngIf="element.fields === 'image' && element.hide_show">
                <mat-label>{{ element.label }}<span *ngIf="element.require">*</span> :</mat-label>
                <div class="adsimage" *ngIf="imagePath">
                    <img [src]="'https://aieventzo.com/upload/' + event_id + '/images/' + imagePath"
                        style="width: 100px; height: 100px; object-fit: contain;">
                </div>
                <div class="input-group mb-3">
                    <input type="file" class="form-control" id="imageFile" accept="image/*"
                        (change)="previewpimage($event)">
                </div>
            </div>

            <!-- ID Proof -->
            <div *ngIf="element.fields === 'id_proof' && element.hide_show">
                <mat-label>{{ element.label }}<span *ngIf="element.require">*</span> :</mat-label>
                <div class="adsimage" *ngIf="logoPath">
                    <img [src]="'https://aieventzo.com/upload/' + event_id + '/id_proof/' + logoPath"
                        style="width: 100px; height: 100px; object-fit: contain;">
                </div>
                <div class="input-group mb-3">
                    <input type="file" class="form-control" id="idProofFile" accept="image/*"
                        (change)="previewpproof($event)">
                </div>
            </div>

            <!-- Date Field -->
            <div *ngIf="element.fields === 'date' && element.hide_show" class="mb-3">
                <mat-form-field appearance="outline">
                    <mat-label>{{ element.label }}</mat-label>
                    <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                        [formControlName]="element.fields" (ngModelChange)="formatDate($event, element.fields)"
                        [required]="element.require">
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>

            <!-- Radio Buttons -->
            <div *ngIf="element.type === 'radio' && element.fields !== 'tic_category' && element.hide_show"
                class="mb-3">
                <mat-label>{{ element.label }}<span *ngIf="element.require">*</span> :</mat-label>
                <mat-radio-group [formControlName]="element.fields">
                    <mat-radio-button *ngFor="let option of element.value.split(',')" [value]="option.trim()">
                        {{ option.trim() }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Select Dropdown -->
            <mat-form-field *ngIf="element.type === 'select' && element.hide_show" appearance="outline">
                <mat-label>{{ element.label }}<span *ngIf="element.require">*</span> :</mat-label>
                <mat-select [formControlName]="element.fields">
                    <mat-option *ngFor="let option of element.value.split(',')" [value]="option.trim()">
                        {{ option.trim() }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Other Text Input -->
            <mat-form-field appearance="outline" *ngIf="element.fields === 'Other' && element.hide_show">
                <mat-label>{{ element.label }}</mat-label>
                <input type="text" matInput placeholder="Please Enter Other Detail" [formControlName]="element.fields">
            </mat-form-field>

            <!-- Default Input Fields -->
            <mat-form-field appearance="outline"
                *ngIf="element.fields !== 'image' && element.fields !== 'id_proof' && element.fields !== 'tic_category' && element.fields !== 'payment_ss' && element.fields !== 'date' && element.type !== 'radio' && element.type !== 'select' && element.type !== 'checkbox' && element.hide_show">
                <mat-label>{{ element.label }}</mat-label>
                <input [type]="element.type" matInput [placeholder]="'Please Enter ' + element.label"
                    [formControlName]="element.fields" [required]="element.require">
            </mat-form-field>

        </div>

        <div class="row" *ngIf="scan_type == 'barcode'">
            <mat-form-field appearance="outline">
                <mat-label>Barcode:</mat-label>
                <input type="text" matInput placeholder="Please Enter Other Detail" [(ngModel)]="barcode"
                    [ngModelOptions]="{standalone: true}">
            </mat-form-field>
        </div>

        <!-- WhatsApp Status -->
        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>Whatsapp Status:</mat-label>
                <mat-select [(ngModel)]="whatsapp_status" [ngModelOptions]="{standalone: true}">
                    <mat-option value="yes">Yes</mat-option>
                    <mat-option value="no">No</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Action Buttons -->
    </div>
    <div mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary">{{ reg_id ? 'Update' : 'Add' }}</button>
    </div>
</form>